import { lazy, Suspense } from "react";
import type { ChewCodeTarget } from "./ChewMarkdown";

const ChewMarkdown = lazy(() => import("./ChewMarkdown").then((module) => ({ default: module.ChewMarkdown })));

/**
 * Authored guide prose is markdown — links to the code it describes above all.
 * Rendering it raw showed reviewers the link syntax instead of the link. The
 * fallback is the source text, so prose is never blank while the renderer loads.
 */
export function GuideProse({ codePaths, onSelectCode, repository, text }: {
  codePaths?: string[];
  onSelectCode?: (target: ChewCodeTarget) => void;
  repository?: string;
  text: string;
}) {
  return (
    <Suspense fallback={<>{text}</>}>
      <ChewMarkdown body={text} codePaths={codePaths} inline onSelectCode={onSelectCode} repository={repository} />
    </Suspense>
  );
}
